import NamedDto from 'modules/base/dto/NamedDto';

export class PetrosimModelInputAttributeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.spreadsheet = null;
		/** @type {string} */
		this.cell = null;
		/** @type {string} */
		this.uom = null;
		/** @type {string} */
		this.expression = null;
		/** @type {string} */
		this.stream = null;
		/** @type {string} */
		this.value = null;
		/** @type {string} */
		this.minValue = null;
		/** @type {string} */
		this.maxValue = null;
		/** @type {boolean} */
		this.useUom = null;
		/** @type {number} */
		this.orderIndex = null;
	}

	/**
	 * @typedef {Object} _PetrosimModelInputAttributeEditDtoProps
	 * @property {string} type
	 * @property {string} spreadsheet
	 * @property {string} cell
	 * @property {string} uom
	 * @property {string} expression
	 * @property {string} stream
	 * @property {string} value
	 * @property {string} minValue
	 * @property {string} maxValue
	 * @property {boolean} useUom
	 * @property {number} orderIndex
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _PetrosimModelInputAttributeEditDtoProps} PetrosimModelInputAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {PetrosimModelInputAttributeEditDtoProps} props
	 * @returns {PetrosimModelInputAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		this.spreadsheet = props.spreadsheet;
		this.cell = props.cell;
		this.uom = props.uom;
		this.expression = props.expression;
		this.stream = props.stream;
		this.value = props.value;
		this.minValue = props.minValue;
		this.maxValue = props.maxValue;
		this.useUom = props.useUom || false;
		this.orderIndex = props.orderIndex;
		return this;
	}
}

export default PetrosimModelInputAttributeEditDto;
